



































import Vue, { PropType } from 'vue';

import FinishLine from '../../structs/finishLine';

export default Vue.extend({
  name: 'GameForm',
  props: {
    finishLine: Object as PropType<FinishLine>,
    step: Number,
  },
  data() {
    return {
      pendingPlayerName: '',
    };
  },
  methods: {
    toggleFinishLine(newVal: boolean): void {
      (this.$refs.finishLineField as HTMLInputElement).focus();
      this.updateFinishLine('enabled', newVal);
    },
    toggleFinishLineMustMatch(newVal: boolean): void {
      this.updateFinishLine('mustMatch', newVal);
    },
    addPlayer(): void {
      this.$emit('add-player', this.pendingPlayerName);
      this.pendingPlayerName = '';
    },
    updateFinishLineValue(newVal: number): void {
      this.updateFinishLine('value', newVal);
    },
    updateFinishLine(key: string, value: any): void {
      this.$emit('sync', ['options', 'finishLine', key], value);
    },
    updateStep(newVal: number) {
      this.$emit('sync', ['options', 'step'], newVal);
    },
  },
});
